import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

interface ICentralBankPayment {
  pcb_id: number;
  pcb_account: string;
  pcb_value_date: string;
  pcb_amount: number;
  pcb_debtor_name: string;
  pcb_description: string;
  pcb_status_code: number;
  pcb_error: string;
  pcb_status_desc: string;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface ICentralBankPaymentListOutput {
  items: ICentralBankPayment[];
  paging: IPaging;
}

interface ICentralBanlPaymentListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  account: string | null;
  statusCode: string | null;
  dateFrom: string | null;
  dateTo: string | null;
}

export const fetchCentralBankPaymentList = async (
  payload: ICentralBanlPaymentListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.account) {
    searchQuery += `&account=${payload.account}`;
  }
  if (payload.statusCode) {
    searchQuery += `&statusCode=${payload.statusCode}`;
  }
  if (payload.dateFrom) {
    searchQuery += `&dateFrom=${payload.dateFrom}`;
  }
  if (payload.dateTo) {
    searchQuery += `&dateTo=${payload.dateTo}`;
  }

  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment-central-bank/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: ICentralBankPaymentListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IStatusCodes {
  statusCode: number;
  statusDesc: string;
}

interface ICentralBankPaymentStatusCodesOutput {
  data: IStatusCodes[];
}

export const fetchCentralBankPaymentStatusCodes =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'get',
      `${Environment.API_BASE_URL}/api/payment-central-bank/statusCodes/list`
    );

    let _data: ICentralBankPaymentStatusCodesOutput = data.data;
    let output: Types.ResponseOutput = {
      message: data.message,
      data: _data,
      status: data.status,
    };
    return output;
  };

interface ICentralBankPaymentAccountsOutput {
  account: string[];
}

export const fetchCentralBankPaymentAccounts =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'get',
      `${Environment.API_BASE_URL}/api/payment-central-bank/accounts/list`
    );

    let _data: ICentralBankPaymentAccountsOutput = data.data;
    let output: Types.ResponseOutput = {
      message: data.message,
      data: _data,
      status: data.status,
    };
    return output;
  };

interface IUpdateCentralBankPaymentStatusInput {
  id: number;
  statusCode: number;
}
export const updateCentralBankPaymentStatus = async (
  payload: IUpdateCentralBankPaymentStatusInput
) => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/payment-central-bank/${payload.id}/update`,
    {
      statusCode: payload.statusCode,
      error: null,
    }
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const fetchCentralBankPayments = async () => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/payment-central-bank/fetchPayments`,
    {}
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const matchPcbPayments = async () => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/payment-central-bank/matchPcbPayments`,
    {}
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
